import { useContext } from "react";

import { ArticleCard } from "@baseComponents/ArticleCard";
import { BlogContext } from "@context/BlogContext";
import { useMediaQueryBreakpoint } from "@hooks";

import { SingleBlogPreviewContainer } from "./SingleBlogPreview.styled";

type SingleBlogPreviewProps = {
  postName: string;
};

export const SingleBlogPreview = ({ postName }: SingleBlogPreviewProps) => {
  const { isTablet, isDesktop, desktopThreshold } = useMediaQueryBreakpoint();
  const blogContext = useContext(BlogContext);

  return (
    <SingleBlogPreviewContainer>
      <ArticleCard
        size={isDesktop ? "big" : isTablet ? "medium" : "small"}
        {...blogContext.getArticleCardByName(postName)}
        nextImageSizes={`(min-width: ${desktopThreshold}px) 60vw, 100vw`}
      />
    </SingleBlogPreviewContainer>
  );
};
